<template>
    <rkm-area
        background-color="secondary"
        header-prefix-icon="check-circle"
        title="Finalização do atendimento"
        type="box"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-radio-group
                    :options="data.form.demandaTipos"
                    disabled
                    label="Tipo de demanda"
                    v-model="data.model.demandaTipo"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="!!data.model.demandaTipo">
            <rkm-col cols="12">
                <rkm-form-radio-group
                    :options="atendimentoTipos"
                    :validations="validations.atendimentoTipo"
                    label="Tipo de atendimento"
                    text-field="nome"
                    v-model="data.model.atendimentoTipoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.additionals.isAtendimentoSaudeBucal">
            <rkm-col cols="12">
                <rkm-form-radio-group
                    :options="consultaTiposFiltrados"
                    :validations="validations.consultaTipo"
                    label="Tipo de consulta"
                    text-field="descricao"
                    v-model="data.model.saudeBucal.consultaTipoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :search-fields="fields.usuario"
                    :text-field="value => `${value.cidadaoNome}${value.cidadaoCns ? ' - ' + formatCns(value.cidadaoCns) : null}`"
                    label="Atendimento compartilhado"
                    v-model="data.model.atendimentoCompartilhadoUsuario"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.additionals.isAtendimentoSaudeBucal">
            <rkm-col cols="12">
                <rkm-form-checkbox-group
                    :options="data.form.saudeBucal.fornecimentos"
                    class="m-0"
                    label="Fornecimento"
                    text-field="nome"
                    v-model="data.model.saudeBucal.fornecimentos"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <BoxProcedimentoAdministrativo :data="data" />

        <BoxCasoSuspeito
            :data="data"
            class="mt-3"
        />

        <rkm-row class="mt-3">
            <rkm-col cols="12">
                <rkm-form-select
                    :options="data.form.racionalidadesSaude"
                    label="Racionalidade em saúde (Exceto alopatia/convencional)"
                    show-default-option
                    text-field="descricao"
                    v-model="data.model.racionalidadeSaudeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <template v-if="data.additionals.criaFichaAtencaoBasica">
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-select
                        :options="data.form.equipes"
                        label="Equipe"
                        show-default-option
                        text-field="descricao"
                        v-model="data.model.equipeId"
                        value-field="id"
                        :validations="validations.equipe"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.turnos"
                        :validations="validations.turno"
                        label="Turno"
                        text-field="nome"
                        v-model="data.model.turnoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.locaisAtendimento"
                        :validations="validations.atencaoBasicaLocalAtendimento"
                        label="Local de atendimento"
                        text-field="descricao"
                        v-model="data.model.atencaoBasicaLocalAtendimentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        :options="condutasFiltradas"
                        :validations="validations.condutas"
                        label="Condutas"
                        text-field="descricao"
                        v-model="data.model.condutas"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </template>

        <rkm-row v-if="data.additionals.precisaInformarConclusaoTratamento">
            <rkm-col cols="12">
                <rkm-form-radio-group
                    :validations="validations.isTratamentoConcluido"
                    label="Conclusão de tratamento"
                    v-model="data.model.isTratamentoConcluido"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>

        <rkm-area
            v-if="data.additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar"
            background-color="secondary"
            title="Atendimento domiciliar - EMAD"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="4" v-if="data.additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar">
                    <rkm-form-select
                        label="Tipo de atendimento"
                        :options="data.form.tiposAtendimento"
                        v-model="data.model.emadTipoAtendimentoId"
                        :validations="validations.emadTipoAtendimento"
                        value-field="id"
                        text-field="descricao"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="4" v-if="data.additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar">
                    <rkm-form-select
                        label="Modalidade"
                        :options="data.form.modalidades"
                        v-model="data.model.emadModalidadeId"
                        :validations="validations.emadModalidade"
                        value-field="id"
                        text-field="descricao"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="4" v-if="data.additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar">
                    <rkm-form-select
                        label="Conduta/Desfecho"
                        :options="data.form.condutaDesfecho"
                        v-model="data.model.emadCondutaDesfechoId"
                        :validations="validations.emadCondutaDesfecho"
                        value-field="id"
                        text-field="descricao"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="data.additionals.criaFichaAtencaoBasicaAvaliacao && this.fichaAvaliacao && !data.additionals.hasAvaliacaoElegibilidade"
            background-color="secondary"
            title="Avaliaçăo de elegibilidade e admissăo - EMAD"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="4" v-if="data.additionals.criaFichaAtencaoBasicaAvaliacao">
                    <rkm-form-select
                        label="Procedência"
                        :options="data.form.procedencias"
                        v-model="data.model.emadProcedenciaId"
                        :validations="validations.emadProcedencia"
                        value-field="id"
                        text-field="descricao"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="8" v-if="!sugestao && data.additionals.criaFichaAtencaoBasicaAvaliacao">
                    <rkm-form-input-autocomplete
                        :repository="repositories.cid"
                        :request-query-string-params="{
                            sexo: data.additionals.paciente.sexoIdentificador,
                        }"
                        :results-limit= "20"
                        :search-fields="fields.cid"
                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                        label="CID 10"
                        v-model="data.model.emadCidPrimarioId"
                        :validations="validations.cid"
                    >

                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group
                                    v-model="sugestao"
                                    :disabled="data.cidSugestao.length === 0"
                                >
                                    <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                    <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col cols="8" v-if="sugestao && data.additionals.criaFichaAtencaoBasicaAvaliacao">
                    <rkm-form-select
                        :options="data.cidSugestao"
                        :validations="validations.cid"
                        label="CID 10"
                        show-default-option
                        text-field="codigoNome"
                        v-model="data.model.emadSelectCidPrimarioId"
                        value-field="id"
                    >

                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="sugestao">
                                    <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                    <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="4" v-if="data.additionals.criaFichaAtencaoBasicaAvaliacao">
                    <rkm-form-select
                        label="Cuidador"
                        :options="data.form.cuidador"
                        v-model="data.model.emadCuidadorId"
                        value-field="id"
                        text-field="descricao"
                    />
                </rkm-col>

                <rkm-col cols="4" v-if="data.model.emadCuidadorId != 1">
                    <rkm-form-input
                        label="CNS"
                        v-model="data.model.emadCnsCuidador"
                        v-mask="mask.cns"
                        :validations="validations.cns"
                        :disabled="!!data.model.emadCpfCuidador"
                    />
                </rkm-col>

                <rkm-col cols="4" v-if="data.model.emadCuidadorId != 1">
                    <rkm-form-input
                        label="CPF"
                        v-model="data.model.emadCpfCuidador"
                        v-mask="mask.cpf"
                        :validations="validations.cpf"
                        :disabled="!!data.model.emadCnsCuidador"
                    />
                </rkm-col>

                <rkm-col cols="4" v-if="data.additionals.criaFichaAtencaoBasicaAvaliacao">
                    <rkm-form-select
                        label="Conclusão"
                        :options="data.form.conclusao"
                        v-model="data.model.emadConclusaoId"
                        :validations="validations.emadConclusao"
                        value-field="id"
                        text-field="descricao"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="data.model.emadConclusaoId && data.model.emadConclusaoId != enums.conclusao.INELEGIVEL">
                <rkm-col>
                    <rkm-form-radio-group
                        v-model="data.model.emadConclusaoJustificativa"
                        :validations="validations.emadConclusaoJustificativa"
                        name="Justificativa"
                    >
                        <rkm-form-radio
                            v-for="justificativa in data.form.elegivel"
                            :key="justificativa.id"
                            :value="justificativa.id"
                            class="w-25 m-0"
                        >
                            {{ justificativa.descricao }}
                        </rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="data.model.emadConclusaoId == enums.conclusao.INELEGIVEL">
                <rkm-col>
                    <rkm-form-checkbox-group
                        v-model="data.model.emadConclusaoJustificativa"
                        :validations="validations.emadConclusaoJustificativa"
                        name="Justificativa"
                    >
                        <rkm-form-checkbox
                            v-for="justificativa in data.form.inelegivel"
                            :key="justificativa.id"
                            :value="justificativa.id"
                            class="w-25 m-0"
                        >
                            {{ justificativa.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row v-if="!data.additionals.oci.ultimaEtapaRealizadaMesmoAtendimento
            && !data.additionals.oci.recusouContinuidadeOci
            && !!data.ociModel.oci
            && data.ociModel.oci.etapaClinicaAtualId !== enums.etapaClinica.ENTRADA"
        >
            <rkm-col
                v-if="data.ociModel.oci.etapaClinicaAtualId !== enums.etapaClinica.ENTRADA_ALTA"
                cols="auto"
            >
                <rkm-form-radio-group
                    :options="ociDesfechosEtapasClinicas"
                    :validations="validations.ociDesfechoEtapaClinica"
                    label="Desfecho do protocolo"
                    text-field="nome"
                    v-model="data.model.ociDesfechoEtapaClinicaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col v-if="data.ociModel.oci.etapaClinicaAtualId === enums.etapaClinica.ENTRADA_ALTA
                || data.model.ociDesfechoEtapaClinicaId === enums.etapaClinica.ALTA">
                <rkm-form-select
                    :options="data.form.apacMotivosSaidaPermanencia"
                    :validations="validations.apacMotivoSaidaPermanencia"
                    label="Motivo de saída/permanêncoa (APAC)"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.apacMotivoSaidaPermanenciaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <BoxDesfecho
            :data="data"
            :fila-id="filaId"
        />
    </rkm-area>
</template>

<script>
// Components.
import BoxCasoSuspeito from './components/caso-suspeito/Index'
import BoxDesfecho from './components/desfecho/Index'
import BoxProcedimentoAdministrativo from './components/procedimento-administrativo/Index'

// Enums.
import AtendimentoTipo from '@/enums/ambulatorio/atendimentoTipo'
import ConsultaTipo from '@/enums/ambulatorio/consultaTipo'
import conclusao from '@/enums/atencao-basica/avaliacao/conclusao'
import condutaEncaminhamento from '@/enums/atencao-basica/atendimento-odontologico/condutaEncaminhamento'
import demandaTipo from '@/enums/ambulatorio/demandaTipo'
import etapaClinica from '@/enums/cadastro/oci/etapaClinica'

// Mixins.
import {formats, repository, mask} from '@/mixins'

export default {
    components: {
        BoxCasoSuspeito,
        BoxDesfecho,
        BoxProcedimentoAdministrativo,
    },
    computed: {
        validations() {
            return {
                atendimentoTipo: {required: true},
                consultaTipo: {required: true},
                equipe: {required: this.data.additionals.criaFichaAtencaoBasica
                    || this.data.additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar
                    || this.data.additionals.criaFichaAtencaoBasicaAvaliacao},
                cid: {required: this.data.additionals.criaFichaAtencaoBasica
                    || this.data.additionals.criaFichaAtencaoBasicaAvaliacao},
                turno: {required: !!this.data.model.equipeId},
                atencaoBasicaLocalAtendimento: {required: !!this.data.model.equipeId},
                condutas: {
                    required:
                        !!this.data.model.equipeId
                        && this.data.additionals.criaFichaAtencaoBasica
                },
                isTratamentoConcluido: {required: true},
                emadCondutaDesfecho: {required: true},
                emadTipoAtendimento: {required: true},
                emadModalidade: {required: true},
                emadProcedencia: {required: true},
                emadConclusao: {required: true},
                emadConclusaoJustificativa: {required: true},
                primario: {required: true},
                cns: {
                    min_max_without_mask: 15,
                    cns: true,
                    required: true,
                    not_same: this.data.additionals.paciente.cns
                },
                cpf: {
                    min_max_without_mask: 11,
                    cpf: true,
                    required: true,
                    not_same: this.data.additionals.paciente.cpf
                },
                ociDesfechoEtapaClinica: {required: true},
                apacMotivoSaidaPermanencia: {required: true},
            }
        },
        fields() {
            return {
                cid: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                usuario:  [
                    {key: 'cadastroCidadao.nome', searchable: true},
                ],
            }
        },
        condutasFiltradas () {
            const tipoConsultaId = this.data.model.saudeBucal.consultaTipoId

            return this.data.form.condutas.map(conduta => {
                return {
                    ...conduta,
                    disabled: this.shouldDisableConduta(conduta, tipoConsultaId)
                }
            })
        },
        ociDesfechosEtapasClinicas() {

            if (!this.data.ociModel.oci) {

                return []
            }

            const etapasClinicas = this.data.form.ocisEtapasClinicas
                .filter(ec => this.data.ociModel.oci.etapasClinicas.includes(ec.id))

            if (this.data.ociModel.oci.etapasClinicas.find(ec => ec === etapaClinica.REABILITACAO)
                || this.data.ociModel.oci.etapasClinicas.find(ec => ec === etapaClinica.TRATAMENTO)
            ) {

                return etapasClinicas.filter(ec => ec.id !== etapaClinica.RETORNO)
            }

            return etapasClinicas
        },
        atendimentoTipos() {
            if (!this.data.model.demandaTipo) {
                return []
            }

            if (this.data.model.demandaTipo === this.enums.demandaTipo.ESPONTANEA) {
                return this.data.form.atendimentoTipos.filter(t => t.isDemandaEspontanea)
            }

            return this.data.form.atendimentoTipos.filter(t => !t.isDemandaEspontanea)
        },
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            cid: this.getConectaSusRepository('sigtap.cid')
        }
        if(this.data.additionals.criaFichaAtencaoBasica && this.data.form.equipes.length == 1) {
            this.data.model.equipeId = this.data.form.equipes[0].id
        }
    },
    data: () => ({
        consultaTiposFiltrados: [],
        enums: {
            atendimentoTipo: AtendimentoTipo,
            conclusao,
            condutaEncaminhamento,
            consultaTipo: ConsultaTipo,
            demandaTipo,
            etapaClinica,
        },
        sugestao: false,
    }),
    methods: {
        shouldDisableConduta(conduta, tipoConsultaId) {
            const codigoEsusCorrigido = Number(conduta.codigoEsus) === 9 ? 17 : Number(conduta.codigoEsus)

            if (codigoEsusCorrigido === this.enums.condutaEncaminhamento.TRATAMENTO_CONCLUIDO) {
                return ![
                    this.enums.consultaTipo.PRIMEIRA_CONSULTA_ODONTOLOGICA_PROGRAMATICA,
                    this.enums.consultaTipo.CONSULTA_RETORNO_ODONTOLOGIA
                ].includes(tipoConsultaId)
            }

            if (codigoEsusCorrigido === this.enums.condutaEncaminhamento.ALTA_EPISODIO) {
                return [
                    this.enums.consultaTipo.PRIMEIRA_CONSULTA_ODONTOLOGICA_PROGRAMATICA,
                    this.enums.consultaTipo.CONSULTA_RETORNO_ODONTOLOGIA
                ].includes(tipoConsultaId)
            }

            return false
        },
        filtrarConsultaTipos(atendimentoTipoId) {
            const isUrgencia = atendimentoTipoId === this.enums.atendimentoTipo.ATENDIMENTO_DE_URGENCIA

            if (!this.data.additionals.isAtendimentoSaudeBucal) {
                this.consultaTiposFiltrados = [...this.data.form.saudeBucal.consultaTipos]
                return
            }

            this.consultaTiposFiltrados = isUrgencia
                ? this.data.form.saudeBucal.consultaTipos.filter(
                    tipoConsulta => tipoConsulta.id !== this.enums.consultaTipo.CONSULTA_RETORNO_ODONTOLOGIA
                )
                : [...this.data.form.saudeBucal.consultaTipos]
        },
    },
    mixins: [formats, repository, mask],
    props: {
        data: {type: Object, required: true},
        fichaAvaliacao: {type: Boolean, default: true},
        filaId: {type: Number, required: true},
    },
    watch: {
        'data.model.emadConclusaoId': function() {
            if(this.data.model.emadConclusaoId == this.enums.conclusao.INELEGIVEL) {
                this.data.model.emadConclusaoJustificativa = []
            } else {
                this.data.model.emadConclusaoJustificativa = null
            }
        },
        'sugestao': function() {
            if(this.sugestao) {
                this.data.model.emadCidPrimarioId = null
            } else {
                this.data.model.emadSelectCidPrimarioId = null
            }
        },
        'data.model.atendimentoTipoId': {
            immediate: true,
            handler(tipoAtendimento) {
                if (!this.data.additionals.isAtendimentoSaudeBucal) {
                    return
                }
                this.filtrarConsultaTipos(tipoAtendimento)
            },
        },
        condutasFiltradas: {
            handler(novasOpcoes) {
                const opcoesValidas = novasOpcoes
                    .filter(o => !o.disabled)
                    .map(o => o.id)

                this.data.model.condutas = this.data.model.condutas
                    .filter(id => opcoesValidas.includes(id))
            },
            immediate: true,
            deep: true
        },
        'data.model.saudeBucal.consultaTipoId': {
            immediate: true,
            handler(novoTipo) {
                this.data.form.condutas.forEach(conduta => {
                    if (this.shouldDisableConduta(conduta, novoTipo)) {
                        conduta.checked = false
                    }
                })
            }
        },
        'data.model.ociDesfechoEtapaClinicaId': function(newValue, oldValue) {
            if (newValue === this.enums.etapaClinica.ALTA) {
                this.showConfirmation(
                    'O protocolo será encerrado ao concluir o atendimento. Deseja continuar?',
                    async () => {
                        if (this.data.ociModel.oci.exameOciRealizado === false) {
                            this.$nextTick().then(() => {
                                this.showAlert(
                                    'O paciente possui exames em aberto relacionados ao protocolo de OCI. Por favor, finalize os exames para concluir o atendimento ou selecione a opção "Retorno".',
                                    'Atenção',
                                )

                                this.data.model.ociDesfechoEtapaClinicaId = undefined
                            })
                        }
                    },
                    async () => {
                        this.data.model.ociDesfechoEtapaClinicaId = oldValue
                    }
                )
            }
        },
    },
}
</script>